import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import classnames from 'classnames';
import React__default, { useState, useEffect } from 'react';
import ResizeButton from './ResizeButton.js';
import { SortableHeader } from './SortableHeader.js';

var Header = function Header(_ref) {
  var columnData = _ref.columnData,
    dataTestId = _ref.dataTestId,
    defaultColDef = _ref.defaultColDef,
    activeSortColumn = _ref.activeSortColumn,
    setActiveSortColumn = _ref.setActiveSortColumn,
    classesForColumn = _ref.classesForColumn,
    onColumnSort = _ref.onColumnSort,
    columnSortDetails = _ref.columnSortDetails;
  var isResizable = (columnData === null || columnData === void 0 ? void 0 : columnData.resizable) !== false ? (columnData === null || columnData === void 0 ? void 0 : columnData.resizable) || (defaultColDef === null || defaultColDef === void 0 ? void 0 : defaultColDef.resizable) : columnData === null || columnData === void 0 ? void 0 : columnData.resizable;
  // take the column's width, fallback on the default column defs, fallback on 250
  // parseFloat it in case they pass a string or include px on the value
  var initialWidth = parseFloat((columnData === null || columnData === void 0 ? void 0 : columnData.width) || (defaultColDef === null || defaultColDef === void 0 ? void 0 : defaultColDef.width) || 250);
  var _useState = useState(initialWidth),
    _useState2 = _slicedToArray(_useState, 2),
    columnWidth = _useState2[0],
    setColumnWidth = _useState2[1];
  if (typeof (columnData === null || columnData === void 0 ? void 0 : columnData.width) === 'string' && columnData.width.includes('%') || typeof (defaultColDef === null || defaultColDef === void 0 ? void 0 : defaultColDef.width) === 'string' && defaultColDef.width.includes('%')) {
    console.error("Hey Canvas User! Looks like you're setting a percentage based width. This isn't supported please update the width in columnData or defaultColDef to a pixel number");
  }
  useEffect(function () {
    setColumnWidth(initialWidth);
  }, [initialWidth]);
  var handleSetHeaderWidth = function handleSetHeaderWidth(newWidth) {
    setColumnWidth(newWidth);
  };
  var columnClasses = classnames('C-TableAdvanced__headerCell', {
    'hc-txt-capitalize': !(columnData !== null && columnData !== void 0 && columnData.headerName),
    isResizable: isResizable
  }, classesForColumn);
  var columnText = (columnData === null || columnData === void 0 ? void 0 : columnData.headerName) || columnData.field;
  return columnSortDetails ? /*#__PURE__*/React__default.createElement(SortableHeader, {
    style: {
      width: "".concat(columnWidth, "px")
    },
    activeSortColumn: activeSortColumn,
    columnClasses: columnClasses,
    columnField: columnData.field,
    columnSort: columnSortDetails,
    columnText: columnText,
    columnWidth: columnWidth,
    dataTestId: dataTestId,
    onColumnSort: onColumnSort,
    setActiveSortColumn: setActiveSortColumn
  }, isResizable && /*#__PURE__*/React__default.createElement(ResizeButton, {
    headerWidth: columnWidth,
    setHeaderWidth: handleSetHeaderWidth
  })) :
  /*#__PURE__*/
  //header is div not th to match sortable columns that needed more style flexibility
  React__default.createElement("div", {
    key: "headerCell-".concat(columnData.field),
    className: columnClasses,
    scope: "col",
    role: "columnheader",
    "data-testid": dataTestId ? "".concat(dataTestId, "-header-").concat(columnData.field) : null,
    style: {
      width: "".concat(columnWidth, "px")
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "C-HeaderCell__cellOverflow"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "C-HeaderCell__text"
  }, columnText)), isResizable && /*#__PURE__*/React__default.createElement(ResizeButton, {
    headerWidth: columnWidth,
    setHeaderWidth: handleSetHeaderWidth
  }));
};

export { Header as default };
